import React, { useState, useEffect } from 'react';
import { useSelector } from 'react-redux';
import { useSpring } from '@react-spring/web';
import StickySubmitWrapper from "./stickySubmit.styles";
import NextButton from "@components/nextButton";
import { useFormButtonContext } from "../../context/formContext/submitButton";
import { FORM_ID } from "../../../../constants/commonConstants";
// import { useOnMount } from "@hooks";
import { isIE11 } from "@utils/helpers/browserHelper";
import { useOnMount } from "@hooks/useOnMount";

// Custom hook to handle on mount effects
// const useOnMount = (callback) => {
//   useEffect(() => {
//     callback();
//   }, []);
// };

// Custom hook for delayed opacity
const useDelayedOpacity = () => {
  const [delayedOpacity, setDelayedOpacity] = useState(0);

  useOnMount(() => {
    const fadeInDelay = 1200;
    setTimeout(() => setDelayedOpacity(1), fadeInDelay);
  });

  return delayedOpacity;
};

// Main component
export const StickySubmit = ({ submitForm }) => {
  const { buttonText, hidden } = useFormButtonContext();
  const { isFetching } = useSelector((state) => state.loanForm);
  const delayedOpacity = useDelayedOpacity();

  const hiddenStyle = useSpring({
    opacity: hidden ? 0 : delayedOpacity,
    from: { opacity: 0 },
  });

  const ieSubmit = () => {
    if (isIE11) {
      submitForm();
    }
  };

  return hidden ? <></> : (
    <StickySubmitWrapper bottom style={hiddenStyle}>
      <NextButton
        form={FORM_ID}
        id="submitButton"
        type="submit"
        onClick={ieSubmit}
        text={buttonText}
        isFetching={isFetching}
      />
    </StickySubmitWrapper>
  );
};

// const useDelayedOpacity = () => {
//   const [delayedOpacity, setDelayedOpacity] = useState(0);
//   useOnMount(() => {
//     const fadeInDelay = 1200;
//     setTimeout(() => setDelayedOpacity(1), fadeInDelay);
//   });
  
//   return delayedOpacity;
// };

// export const StickySubmit = ({submitForm}) => {
//   let { buttonText, hidden } = useFormButtonContext();
//   const { isFetching } = useSelector((state) => state.loanForm);
//   const delayedOpacity = useDelayedOpacity();

//   const hiddenStyle = useSpring({
//     opacity: hidden ? 0 : delayedOpacity,
//     from: {
//       opacity: 0,
//     }
//   });
  
//   const ieSubmit = () => {
//     if (isIE11) {
//       (() => submitForm())();
//     }
//   };
  
//   return (
//     <StickySubmitWrapper bottom style={hiddenStyle}>
//       <NextButton form={FORM_ID} id="submitButton" type="submit" onClick={ieSubmit} text={buttonText} isFetching={isFetching} /> 
//     </StickySubmitWrapper>
//   );
// };